import BaseModule from './BaseModule';
import Factory from '../libs/Factory';
import {requireElement} from "../libs/Helpers";

export default class Cover extends BaseModule {
    constructor(el: HTMLDivElement, factory: Factory) {
        super(el, factory, 'Cover');

        const mm = matchMedia("(width < 768px)");
        if (mm.matches) {
            return;
        }

        Promise.all([
            import(/* webpackChunkName: "gsap" */ 'gsap'),
            import(/* webpackChunkName: "gsap" */ 'gsap/ScrollTrigger'),
        ]).then(([gsapModule, ScrollTriggerModule]) => {
            const gsap = gsapModule.gsap;
            gsap.registerPlugin(ScrollTriggerModule.ScrollTrigger);

            const box = el.getBoundingClientRect();
            const element = requireElement(el, '.cover-element');
            const child = requireElement(el, '.e-grid > .e-con-inner')
            const boundingBox = child.getBoundingClientRect();
            const elementBox = element.getBoundingClientRect();

            const maxHeight = (boundingBox.top - box.top) + boundingBox.height - elementBox.height + boundingBox.width / (16 / 9);
            el.style.height = `${maxHeight}px`;

            gsap.to(element, {
                width: '100%',
                scrollTrigger: {
                    trigger: el,
                    start: "top top",
                    end: "bottom top",
                    pin: true,
                    scrub: true,
                }
            });
        });
    }
}